module.exports = __webpack_public_path__ + "static/media/carroFulcro.6e6d144b.svg";